var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgContactStatus = function SvgContactStatus(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 12.375C8.61396 12.375 10.125 10.864 10.125 9C10.125 7.13604 8.61396 5.625 6.75 5.625C4.88604 5.625 3.375 7.13604 3.375 9C3.375 10.864 4.88604 12.375 6.75 12.375Z",
    stroke: "#7EAAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 14.625C5.25816 14.625 3.82742 15.2176 2.77252 16.2725C1.71763 17.3274 1.125 18.7582 1.125 20.25V23.625H3.375L4.5 32.625H9",
    stroke: "#7EAAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 12.375C31.114 12.375 32.625 10.864 32.625 9C32.625 7.13604 31.114 5.625 29.25 5.625C27.386 5.625 25.875 7.13604 25.875 9C25.875 10.864 27.386 12.375 29.25 12.375Z",
    stroke: "#7EAAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 14.625C30.7418 14.625 32.1726 15.2176 33.2275 16.2725C34.2824 17.3274 34.875 18.7582 34.875 20.25V23.625H32.625L31.5 32.625H27",
    stroke: "#7EAAFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10.125C20.4853 10.125 22.5 8.11028 22.5 5.625C22.5 3.13972 20.4853 1.125 18 1.125C15.5147 1.125 13.5 3.13972 13.5 5.625C13.5 8.11028 15.5147 10.125 18 10.125Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 20.25C25.875 18.1614 25.0453 16.1584 23.5685 14.6815C22.0916 13.2047 20.0886 12.375 18 12.375C15.9114 12.375 13.9084 13.2047 12.4315 14.6815C10.9547 16.1584 10.125 18.1614 10.125 20.25V23.625H13.5L14.625 34.875H21.375L22.5 23.625H25.875V20.25Z",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-status.6d8ff71c.svg";
export { ForwardRef as ReactComponent };